import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "./WorkspaceContainer";
import Routes from "../../../../navigation/route/Route";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import {default as Transaction, ReconciliationStatus} from "../../../../model/transaction/Transaction";
import {TransactionApiDto} from "../../../../api/model/rest";
import {none, option, Option} from "ts-option";
import IgnoreTransactionModal from "../presenter/IgnoreTransactionModal";
import {PaymentMethod} from "../../../../model/payment/Payment";
import {CellInfo} from "react-table";
import IconSmall from "../../../../hiberUiKit/src/atoms/Icon/IconSmall";
import {WildcardFilterColumnType} from "../../../../model/workspace/WildcardFilter";

type Props = RouteComponentProps<any>;

interface State {
	/**
	 * If defined, transaction ignore/unignore modal is displayed.
	 */
	transactionToIgnore: Option<Transaction>;
}

class TransactionWorkspaceContainer extends React.Component<Props, State> {
	refs: {
		workspaceContainer: WorkspaceContainer;
	};

	constructor(props: Props) {
		super(props);
		this.state = {transactionToIgnore: none};
	}

	render() {
		const pageNo = this.props.location.state && this.props.location.state.pageNo ? this.props.location.state.pageNo : 1;
		return (
			<>
				<WorkspaceContainer ref={"workspaceContainer"}
									workspaceName={WorkspaceName.Transactions}
									wildcardFilterColumnType={WildcardFilterColumnType.Transactions}
									onRowClick={this.onRowClick}
									isRowIgnored={this.isRowIgnored}
									rowToId={(row) => row.id}
									lastColumn={this.lastColumn}
									lastColumnWidth={50}
									pageNo={pageNo}/>
				{this.state.transactionToIgnore.map(this.renderIgnoreModal).orNull}
			</>
		);
	}

	onRowClick = (rowId: string, rowData: TransactionApiDto) => {
		const pageNo = this.refs.workspaceContainer.state.data.currentPageNo;
		if (PaymentMethod[rowData.paymentMethod] === PaymentMethod.STRIPE_PAYOUT) {
			this.props.history.push(Routes.StripePayoutDetailsView(rowId), {pageNo});
		}
		else if (PaymentMethod[rowData.paymentMethod] === PaymentMethod.GOCARDLESS_PAYOUT) {
			this.props.history.push(Routes.GoCardlessPayoutDetailsView(rowId), {pageNo});
		}
		else {
			this.props.history.push(Routes.TransactionDetailsView(rowId), {pageNo});
		}
	};

	lastColumn = (row: CellInfo) => {
		const rowData: TransactionApiDto = row.original;
		if (rowData.status.reconcileStatus === ReconciliationStatus.RECONCILED) {
			return null;
		}
		const icon = this.isRowIgnored(rowData) ? Icon.Reset : Icon.X;
		return (
			<div style={{float: "right", paddingRight: "15px"}}
				 onClick={(e) => {
					 e.stopPropagation();
					 this.setState({transactionToIgnore: option(Transaction.fromJson(rowData))})
				 }}>
				<IconSmall icon={icon} variant={"gray"}/>
			</div>
		);
	};

	isRowIgnored = (rowData: TransactionApiDto) => rowData.status.reconcileStatus === ReconciliationStatus.IGNORED;

	renderIgnoreModal = (transaction: Transaction) => {
		return (
			<IgnoreTransactionModal transaction={transaction}
									onClose={() => this.setState({transactionToIgnore: none})}
									onSuccess={this.onIgnoreSuccess}/>
		);
	};

	onIgnoreSuccess = () => {
		this.refs.workspaceContainer.refreshCurrentPage();
		this.setState({transactionToIgnore: none});
	}
}

export default withRouter(TransactionWorkspaceContainer);
